import { useElementShown } from '@hh.ru/analytics-js';
import authorizeLoginProfessionButtonClick from '@hh.ru/analytics-js-events/build/career_platform/authorization/authorize_login_profession_button_click';
import authorizeLoginProfessionElementShown from '@hh.ru/analytics-js-events/build/career_platform/authorization/authorize_login_profession_element_shown';
import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { Button, Card, Text, VSpacing } from '@hh.ru/magritte-ui';
import { SPALink } from '@hh.ru/redux-spa-middleware';

import { LOGIN_ROUTE } from 'src/app/routesUtils';
import { ProfessionId } from 'src/types/profession';

const TrlKeys = {
    title: 'career-platform.profession.card-match-skills-login.title',
    subtitle: 'career-platform.profession.card-match-skills-login.subtitle',
    button: 'career-platform.profession.card-match-skills-login.button',
};

interface Props {
    professionId: ProfessionId;
}

const CardMatchSkillsLogin: TranslatedComponent<Props> = ({ trls, professionId }) => {
    const ref = useElementShown(authorizeLoginProfessionElementShown, { professionId, authType: 'BANNER' });

    const onClickAuthorize = () => authorizeLoginProfessionButtonClick({ professionId, authType: 'BANNER' });

    return (
        <Card
            ref={ref}
            style="contrast"
            padding={16}
            borderRadius={16}
            borderBottomLeftRadius={24}
            borderBottomRightRadius={24}
            stretched
            data-qa="card-match-skills_login"
        >
            <Text typography="subtitle-1-semibold" Element="p">
                {trls[TrlKeys.title]}
            </Text>
            <VSpacing default={4} />
            <Text typography="paragraph-3-regular">{trls[TrlKeys.subtitle]}</Text>
            <VSpacing default={16} />
            <Button
                mode="primary"
                style="accent"
                size="small"
                stretched
                Element={SPALink}
                to={LOGIN_ROUTE}
                isSeoLink
                onClick={onClickAuthorize}
            >
                {trls[TrlKeys.button]}
            </Button>
        </Card>
    );
};

export default translation(CardMatchSkillsLogin);
